import { render } from "./asset_register.html?vue&type=template&id=0aed8881&external"
import script from "./asset_register.js?vue&type=script&lang=js&external"
export * from "./asset_register.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__